/** Every number, date, and field label the UI shows goes through these. */

const ISO_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/;

export function formatNumber(value: number): string {
  if (Number.isInteger(value)) return value.toLocaleString("en-US");
  return value.toLocaleString("en-US", { maximumFractionDigits: Math.abs(value) < 1 ? 3 : 2 });
}

export function formatInstant(value: string): string {
  return new Date(value).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
}

export function formatTime(value: string): string {
  return new Date(value).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

export function isInstant(value: unknown): value is string {
  return typeof value === "string" && ISO_INSTANT.test(value);
}

/** A value as display text; objects and arrays are summarized, not dumped. */
export function formatValue(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "number") return formatNumber(value);
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (isInstant(value)) return formatInstant(value);
  if (Array.isArray(value)) return value.every((item) => typeof item !== "object" || item === null) ? value.map(formatValue).join(", ") : `${value.length} items`;
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

/** `startsAt` → "Starts at", `homeTeam.name` → "Home team name". */
export function humanize(key: string): string {
  const words = key
    .replace(/[._-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .trim()
    .toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** Orders values for sorting: numbers numerically, everything else as text. */
export function compareValues(a: unknown, b: unknown): number {
  if (a === b) return 0;
  if (a === null || a === undefined) return 1;
  if (b === null || b === undefined) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b));
}
